import { fetcher } from "helpers/fetcher";

import {
  TGetBUCorporationMemberReq,
  TGetBUCorporationMemberRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUCorporationMember = async (
  params?: TGetBUCorporationMemberReq
) => {
  return await fetcher<TGetBUCorporationMemberRes, TGetBUCorporationMemberReq>(
    ENDPOINT.BU.GET_BU_CORPORATION_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_CORPORATION_MEMBER.version,
        [API_HEADER.BU_ID]: params?.idBu,
      },
    }
  );
};

export const queryGetBUCorporationMember = async (
  params?: TGetBUCorporationMemberReq
) => {
  return (await getBUCorporationMember(params)).data;
};

queryGetBUCorporationMember._key = (params?: TGetBUCorporationMemberReq) => [
  ENDPOINT.BU.GET_BU_CORPORATION_MEMBER.url,
  params,
];
